// US state / territory full-name → USPS 2-letter abbreviation.
// Used by the city prompt formatter so US cities read "Dallas, TX"
// instead of "Dallas, Texas" — matches the UI density we want for
// the small primary line of the prompt.
//
// Source dataset: Natural Earth populated places' ADM1NAME field, which
// uses full names ("Texas", "District of Columbia"). Includes territories
// and DC because NE's US point coverage extends to them.

const STATE_ABBR: Record<string, string> = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  'District of Columbia': 'DC',
  'Puerto Rico': 'PR',
  Guam: 'GU',
  'American Samoa': 'AS',
  'U.S. Virgin Islands': 'VI',
  'Northern Mariana Islands': 'MP',
};

/**
 * Look up a USPS 2-letter abbreviation for a US state / territory by
 * full name. Returns null for unknown names so callers can fall back
 * to the full subdivision string rather than rendering nothing.
 */
export function usStateAbbreviation(stateName: string): string | null {
  return STATE_ABBR[stateName] ?? null;
}
